import { render } from "./ForgotSimplePassword.vue?vue&type=template&id=c4577f98&scoped=true&ts=true"
import script from "./ForgotSimplePassword.vue?vue&type=script&lang=ts"
export * from "./ForgotSimplePassword.vue?vue&type=script&lang=ts"

import "./ForgotSimplePassword.vue?vue&type=style&index=0&id=c4577f98&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4577f98"]])

export default __exports__